import { Link } from "react-router";
import { Button } from "../../components/ui/button";
import { FileQuestion } from "lucide-react";

const NotFoundScreen = () => {
  return (
    <div className="text-center">
      <div className="mb-8 flex justify-center">
        <FileQuestion className="h-20 w-20 text-muted-foreground" />
      </div>

      <h2 className="text-2xl font-bold text-foreground mb-2">
        Page Not Found
      </h2>
      <p className="text-muted-foreground mb-6">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <div className="flex flex-col space-y-4">
        <Button asChild variant="default">
          <Link to="/">Go to Homepage</Link>
        </Button>

        <Button asChild variant="outline">
          <Link to="/dashboard">Go to Dashboard</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFoundScreen;
